import { render, staticRenderFns } from "./testDataDownloadList.vue?vue&type=template&id=1b0e02e2&scoped=true"
import script from "./testDataDownloadList.vue?vue&type=script&lang=js"
export * from "./testDataDownloadList.vue?vue&type=script&lang=js"
import style0 from "./testDataDownloadList.vue?vue&type=style&index=0&id=1b0e02e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e02e2",
  null
  
)

export default component.exports